export default __webpack_public_path__ + "static/gem-of-the-fleet-5d94161f5d3ed78f551a3bb12e6cebdc.jpg";